import abcLogo from 'assets/img/logos/abc-logo.svg';
import certainteedLogo from 'assets/img/logos/certainteed-logo.svg';

export interface Partner {
  id: number;
  isCobrand: boolean;
  logo: string;
  name: string;
  parentOrgCode: string;
  subdomain: string;
}

const partners: readonly Partner[] = [
  {
    id: 459066,
    isCobrand: true,
    logo: abcLogo,
    name: 'ABC',
    parentOrgCode: '15ec17b5-0078-4b36-95a2-391fafe87421',
    subdomain: 'abcsupply',
  },
  {
    id: 1131,
    isCobrand: false,
    logo: certainteedLogo,
    name: 'Certainteed',
    parentOrgCode: 'd4bdb2c6-852e-4673-8e9d-05f9aa271667',
    subdomain: 'certainteed',
  },
] as const;

export { partners };
